module.exports = __webpack_public_path__ + "static/contactInfoBackground.981aa255.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/contactInfoBackground.jpg
// module id = 411
// module chunks = 114276838955818